import React from "react"
import * as styles from "./sectionHeadingDescription.module.scss"

import { Link } from "gatsby"
import { useLocalPath } from "../../../hooks"
import { RichText } from "../../Layout/RichText/RichText"
import { useLocale } from "../../../hooks" 
const SectionHeadingDescription = ({ section }) => {

    const {
        heading,
        description,
        slug,
        buttonText,
        simpleDescription2
    } = section

    const locale = useLocale()
    return (
        <div className={styles.principleContainer}>
            <div className={styles.textContainer}>
                {
                    heading 
                        ?  (locale === 'pl-PL') ? <a target="_blank" href={useLocalPath(slug)}>
                                <h2 className="yellow_border">{heading}</h2>
                            </a> : <a target="_blank" href={slug}>
                                <h2 className="yellow_border">{heading}</h2>
                            </a>
                        : null
                }
            </div>
            <div className={styles.richContainer}>
                {
                    description
                        ? <RichText content={description} />
                        : null
                }
            </div>
            {
                buttonText
                    ? <Link to={useLocalPath(slug)}><button className={styles.btnInfo}>{buttonText}</button></Link>
                    : null
            }
            {
                simpleDescription2
                    ? <p className={styles.descriptionContainer2}>{simpleDescription2.simpleDescription2}</p>
                    : null
            }
        </div >
    )
}

export default SectionHeadingDescription
